module.exports = __webpack_public_path__ + "img/bce.5a6f5e93.jpg";